import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'CairoCure';
  showHead: boolean = false;
    idleTimeout: any;
  idleTime = 1800000; // 10 دقائق بالملي ثانية
  constructor(private router: Router) {
    window.onpopstate = () => {

const token = sessionStorage.getItem("token");

if(!token){

this.router.navigate(['/login']);
}
    }
    // on route change to '/login', set the variable showHead to false
      router.events.forEach((event) => {
        if (event instanceof NavigationStart) {
          if (event['url'] == '/') {
            this.showHead = false;
          } else {
            // console.log("NU")
            this.showHead = true;
          }
        }
      });
    }

ngOnInit() {

  this.resetTimer();
  window.addEventListener('mousemove', () => this.resetTimer());
  window.addEventListener('keydown', () => this.resetTimer());
  window.addEventListener('click', () => this.resetTimer());
}

resetTimer() {
  clearTimeout(this.idleTimeout);
  this.idleTimeout = setTimeout(() => {
    this.logout();
  }, this.idleTime);
}

logout() {
  alert('تم تسجيل الخروج بسبب عدم النشاط');
  // localStorage.clear();
  window.location.href = '/';
}
}
